<mat-list>
  @for (nav of navRoutes; track nav) {
  <mat-list-item class="menu-item mat-padding-none list-container" detail="false" (click)="changeRoute(nav.link)" href="javascript:;">
    <div class="list-item">
      @if (nav.customIcon != null && nav.customIcon) {
      <mat-icon class="list-icon"><img src="{{ nav.icon }}" /></mat-icon>
      } @if (nav.customIcon == null || !nav.customIcon) {
      <mat-icon class="list-icon">{{ nav.icon + '-outline' }}</mat-icon>
      }
      <mat-label>{{ nav['title'] }}</mat-label>
    </div>
  </mat-list-item>
  }
</mat-list>
